import React from 'react';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { Label } from '../componentes_generales/componentes_formulario/labels/';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol} from '../componentes_generales/componentes_formulario/contenedores/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import  global_axios  from '../../funciones_globales/interaccionapi';
import '../componentes_generales/componentes_formulario/fields/busqueda_especifica/busq-especif.css'
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';


const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

class FormImport05 extends React.Component{
    constructor(props){
        super(props);
            this.state = {
                periodo: '',
                data_result:[],
                gridOptions: {
                    context: {
                        componentParent: this
                    },
                    enableCellChangeFlash: true,
                    onCellValueChanged: (event)=>{

                        var controlYear;
                        
                        controlYear = this.biciesto(this.state.periodo);                       
                        
                        if(event.data.Enero < 1 || event.data.Enero > 31){
                            delete event.data.Enero;
                        }else if(controlYear=== true && (event.data.Febrero < 1 || event.data.Febrero > 29) ){
                            delete event.data.Febrero;
                        }else if(controlYear=== false && (event.data.Febrero < 1 || event.data.Febrero > 28) ){
                            delete event.data.Febrero;
                        }else if(event.data.Marzo < 1 || event.data.Marzo > 31){
                            delete event.data.Marzo;
                        }else if(event.data.Abril < 1 || event.data.Abril > 30){
                            delete event.data.Abril;
                        }else if(event.data.Mayo < 1 || event.data.Mayo > 31){
                            delete event.data.Mayo;
                        }else if(event.data.Junio < 1 || event.data.Junio > 30){
                            delete event.data.Junio;
                        }else if(event.data.Julio < 1 || event.data.Julio > 31){
                            delete event.data.Julio;
                        }else if(event.data.Agosto < 1 || event.data.Agosto > 31){
                            delete event.data.Agosto;
                        }else if(event.data.Septiembre < 1 || event.data.Septiembre > 30){
                            delete event.data.Septiembre;
                        }else if(event.data.Octubre < 1 || event.data.Octubre > 31){
                            delete event.data.Octubre;
                        }else if(event.data.Noviembre < 1 || event.data.Noviembre > 30){
                            delete event.data.Noviembre;
                        }else if(event.data.Diciembre < 1 || event.data.Diciembre > 31){
                            delete event.data.Diciembre;
                        }
                        this.api.refreshCells();
                    }
                },
                columnDefs:         [   {   header: "Fila",
                                            field: "fila",
                                            width: 36,
                                            type: "string"                                                 
                                        },
                                        {   header: "Linea",
                                            field: "linea",
                                            width: 410,
                                            type: "string"                                                 
                                        },
                                        {   header: "En.",
                                            field: "Enero",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                                 
                                        },
                                        {   header: "Feb.",
                                            field: "Febrero",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                          
                                        },
                                        {   header: "Mzo.",
                                            field: "Marzo",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                             
                                        },
                                        {   header: "Abr.",
                                            field: "Abril",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                               
                                        },
                                        {   header: "My.",
                                            field: "Mayo",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                               
                                        },
                                        {   header: "Jun.",
                                            field: "Junio",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                               
                                        },
                                        {   header: "Jul.",
                                            field: "Julio",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                               
                                        },
                                        {   header: "Agt.",
                                            field: "Agosto",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                                
                                        },
                                        {   header: "Sept.",
                                            field: "Septiembre",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                                
                                        },
                                        {   header: "Oct.",
                                            field: "Octubre",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                                
                                        },
                                        {   header: "Nov.",
                                            field: "Noviembre",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                                
                                        },
                                        {   header: "Dic.",
                                            field: "Diciembre",
                                            width: 40,
                                            type: "num_entero_edit",
                                            editable: true                                                
                                        },
                                    ],
            }
        this.submit = this.submit.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.getPlanImportacion = this.getPlanImportacion.bind(this);
        this.onGridReady = this.onGridReady.bind(this);
    };

    biciesto(year){
        if ((((year%100)!==0)&&((year%4)===0))||((year%400)===0)){
            return true;
        }else{
            return false;
        }
    }

    onGridReady(params) {
        this.api = params.api;
        this.columnApi = params.columnApi;
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0305');
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0305');
    }

    getPlanImportacion(){
        if(this.state.periodo === ''){
            alert("Digite un periodo");
        }else if(parseInt(this.state.periodo,10) < 0 || parseInt(this.state.periodo,10) >=2050 ){
            alert("Perido digitado fuera de rango o incorrecto");
            this.clear();
        }else{

            var data = {};
            data.periodo = this.state.periodo;
    
            let config_request = {
                method: 'GET',
                url: '/planimportacion/'+this.state.periodo.toString(),
                data
            }

            global_axios(config_request)
            .then((response)=>{
                this.setState({ data_result: response.data})
            })
            .catch(function(error){ 
                if (error.response){
                    alert(error.response.data.msg);
                }
            })
        }
    }

    clear(){
        this.setState({periodo: ''});
        this.setState({data_result: []});
    }

    submit(e){        
        var data = {};
        data.grid = this.state.data_result;
        data.periodo = this.state.periodo;

        data.grid.forEach((element)=>{
            delete element.linea;
            delete element.fila;
        })
        
        if(data.periodo!=='' /*|| parseInt(data.periodo,10)<parseInt(data.periodo,10)*/){

            let config_request = {
                method: 'POST',
                url: '/planimportacion/'+this.state.periodo.toString(),
                data
            }
            global_axios(config_request)
            .then((response)=>{
                alert("Ingreso exitoso");
            })
            .catch(function(error){ 
                if (error.response){
                    alert(error.response.data.msg);
                }
            })

        }else{
            alert("No ha seleccionado un periodo")
        }
    }

    changeYear(event){
        const target = event.target;    
        const value = target.value;
        this.setState({periodo: value});
        this.setState({data_result: []});
    }

    render(){
        return(
            <ContenedorForm porc_ancho={72}>
            <HeaderForm>
                <TituloForm>Plan de importación</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-md-3 col-md-offset-9 col-md-pull-9'>
                                <Label>Perido:</Label>
                                <div className='input-group'>
                                    <InputText name='periodo' value={this.state.periodo} type="number" className='form-control input-sm' placeholder='Año YYYY' onChange={this.changeYear}/>
                                    <span className='input-group-addon addon-busq-especif'><ButtonUnion type="button" className='btn btn-default medida-button-busq-especif' onClick={this.getPlanImportacion}><i className="fa fa-pencil-square-o"></i> Seleccionar</ButtonUnion></span>
                                </div>
                            </ContainerCol>
                        </Row>             
                    </ContainerEdit>
                        <form onSubmit={this.submit.bind(this)}> 
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <AgGridRender altura='300px' data={this.state.data_result} columnas={this.state.columnDefs} gridOptions={this.state.gridOptions} onGridReady={this.onGridReady}/>                                                           
                                </ContainerCol>
                            </Row>
                            <Row>
                                <div className='col-md-12'>
                                    <div className="btn-group pull-right">
                                        <button type="submit" className='btn btn-primary btn-sm'>
                                            <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                        </button>                      
                                    </div>
                                </div>                
                            </Row>
                        </form>
                </CuerpoForm>
            </ContenedorForm>
        );
    }
}

const mapStateToProps = ((state) => {
    return {
      permiso: state.sesion.valoresSesionForm.Permiso,
    };
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({
        generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
    }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormImport05);


